import styled from "styled-components";

export const FrontImg = styled.div`
  background: url("https://images.unsplash.com/photo-1503925802536-c9451dcd87b5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80")
    no-repeat center center/cover;
  width: 90vw;
  height: 70vh;
  margin: 1rem 0;
`;
